export { default as SquareWaveSynth } from "./SquareWaveSynth";
export { default as SineWaveSynth } from "./SineWaveSynth";
export { default as SawtoothWaveSynth } from "./SawtoothWaveSynth";
export { default as TriangleWaveSynth } from "./TriangleWaveSynth";
export { default as DrumKit808 } from "./DrumKit808";
export { default as DrumKitCR8000 } from "./DrumKitCR8000";
export { default as TR303 } from "./TR303";
export { default as MassiveLead } from "./MassiveLead";
export { default as YeahSynth } from './YeahSynth';
